import {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SwalAlertClass} from "core/swalClass";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import {languagesSelect} from "core/languages";
import axiApi from "ApiCaller";
import FormButton from "components/buttons/FormButton";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import {useTranslation} from "react-i18next";

const FormUser = ({setShowCanvas, showCanvas, item, items, setItem, setItemsShown, organizations, panels, reloadData}) => {
    const {t: _CT} = useCustomTranslation(translations);
    const {t: _Tr} = useTranslation("forms");
    const [formData, setFormData] = useState(item);
    const [isNew, setIsNew] = useState(false);
    const Alert = new SwalAlertClass({confirmButtonText: _Tr("labels.accept")});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsNew(!item.email);
        setFormData({...item});
    }, [item]);

    const handleChange = (event) => {
        const {name, value} = event.target;
        let data = {...formData};
        switch (name) {
            case "organizations":
                if (!formData.organizations.includes(value)) {
                    data.organizations.push(value);
                } else {
                    data.organizations = formData.organizations.filter((tok) => tok !== value);
                    let panelsToDelete = [];
                    panels.forEach((panel) => panel.org === value && panelsToDelete.push(panel.token));
                    data.panels = formData.panels.filter((token) => !panelsToDelete.includes(token));
                }
                if (data.organizations.length === 0) {
                    Alert.warning(_CT("alerts.error"), _CT("user.selectOrg"));
                    return false;
                }
                break;
            case "panels":
                if (!formData.panels.includes(value)) {
                    data.panels.push(value);
                } else {
                    data.panels = formData.panels.filter((tok) => tok !== value);
                }
                if (data.panels.length === 0) {
                    Alert.warning(_CT("alerts.error"), _CT("user.selectPanel"));
                    return false;
                }
                break;
            case "is_active":
            case "is_admin":
            case "is_tech":
            case "is_maint":
            case "is_fireman":
            case "dri_user":
                data[name] = !data[name];
                break;
            // case "is_viewer":
            // case "is_report":
            // case "mail_alarm":
            //     data[name] = !data[name];
            // break;
            default:
                data[name] = value;
        }
        setFormData(data);
    };

    const handleClose = () => {
        setShowCanvas(false);
    };

    const checkErrorsForm = () => {
        let message = "";
        if (!formData.organizations.length) {
            message += _CT("user.errorSelectOrg");
        }
        if (!formData.panels.length) {
            message += _CT("user.errorSelectPanel");
        }
        // if (!(formData.is_admin || formData.is_tech || formData.is_viewer || formData.is_report)) {
        // - basta con un rol: administrador, técnico, mantenimiento o conductor (solo app de cabina)
        if (!(formData.is_admin || formData.is_tech || formData.is_maint || formData.dri_user)) {
            message += _CT("user.errorSelectRole");
        }
        if (message) {
            Alert.warning(_CT("user.formErrors"), message);
        }
        return Boolean(message);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (checkErrorsForm()) {
            return false;
        }
        formData.domain = window.location.origin;
        setIsLoading(true);
        axiApi
            .post(`/api/profiles/save/`, formData)
            .then((resp) => {
                if (resp.data.status) {
                    resp.data.message && Alert.info(_CT("alerts.error"), resp.data.message);
                    let indexInAll = null;
                    items.current.all.forEach((item, idx) => {
                        if (item.token === resp.data.item.token) {
                            indexInAll = idx;
                            return false;
                        }
                    });
                    if (!indexInAll && "idx" in item) {
                        indexInAll = item.idx;
                    }
                    indexInAll ? (items.current.all[indexInAll] = resp.data.item) : items.current.all.push(resp.data.item);

                    setItemsShown([...items.current.showed]);
                    handleClose();
                    reloadData();
                } else {
                    Alert.warning(_CT("user.saveError"), resp.data.message);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                Alert.warning(_CT("alerts.error"), _CT("alerts.serverError"));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <Offcanvas
                show={showCanvas}
                onHide={handleClose}
                placement="end"
                backdrop="false"
                scroll={true}
                style={{width: "30%"}}>
                <Offcanvas.Header className="preview-canvas" closeButton>
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="users" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{formData.email ? formData.email : _CT("user.createUser")}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form onSubmit={onSubmit} className="mb-5 pb-5">
                        <div className="row mb-2">
                            <div className="col-md-4 text-md-end">
                                <label className="text-danger fw-bold d-flex align-items-center justify-content-end ">
                                    <FontAwesomeIcon icon="exclamation-circle" className="me-2" />
                                    {_CT("user.isActive")}
                                </label>
                            </div>
                            <div className="col-md-4">
                                <div className="col-md-8 d-flex align-items-center justify-content-center">
                                    <Form.Check
                                        id="is_active"
                                        name="is_active"
                                        checked={formData.is_active}
                                        onChange={handleChange}
                                        className="form-check-lg"
                                    />
                                </div>
                            </div>
                        </div>
                        <hr className="col-10 m-auto mb-4" />
                        <div className="row mt-4">
                            <div className="col-md-4 text-md-end mt-2">
                                <label>{_CT("user.email")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="email"
                                    className="form-control mb-2"
                                    id="email"
                                    name="email"
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 text-md-end mt-2">
                                <label>{_CT("user.firstName")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="first_name"
                                    name="first_name"
                                    required
                                    value={formData.first_name}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 text-md-end mt-2">
                                <label>{_CT("user.lastName")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="last_name"
                                    name="last_name"
                                    required
                                    value={formData.last_name}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 text-md-end mt-2">
                                <label>{_CT("user.phone1")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="phone_1"
                                    name="phone_1"
                                    value={formData.phone_1}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 text-md-end mt-2">
                                <label>{_CT("user.phone2")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="phone_2"
                                    name="phone_2"
                                    value={formData.phone_2}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 text-md-end mt-2">
                                <label>{_CT("user.language")}:</label>
                            </div>
                            <div className="col-md-8">
                                <Form.Select
                                    className="mb-2"
                                    id="language"
                                    name="language"
                                    value={formData.language}
                                    onChange={handleChange}>
                                    {languagesSelect.map((lang, index) => (
                                        <option key={index} value={lang.key}>
                                            {lang.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-4 text-md-end">
                                <label>{_CT("user.accessOrganizations")}:</label>
                            </div>
                            <div className="col-md-8 pt-3 border-top">
                                {organizations.map((org, idx) => (
                                    <div className="col-md-8" key={idx}>
                                        <Form.Check
                                            type="checkbox"
                                            name="organizations"
                                            value={org.token}
                                            label={org.name}
                                            checked={formData.organizations.includes(org.token)}
                                            onChange={handleChange}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-4 text-md-end">
                                <label>{_CT("user.accessPanels")}:</label>
                            </div>
                            <div className="col-md-8 pt-3 border-top">
                                {panels.map((mun, idx) =>
                                    formData.organizations.includes(mun.org) ? (
                                        <div className="col" key={idx}>
                                            <Form.Check
                                                type="checkbox"
                                                name="panels"
                                                value={mun.token}
                                                label={mun.name + " (" + mun.organization_name + ")"}
                                                disabled={!formData.organizations.includes(mun.org)}
                                                checked={formData.panels.includes(mun.token)}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    ) : (
                                        ""
                                    ),
                                )}
                            </div>
                        </div>
                        <div className="row mt-3">
                            <hr className="col-10 m-auto mb-4" />
                            <div className="col-12 text-center">
                                <h5 className="mb-3">{_CT("user.userRole")}</h5>
                                <Form.Check
                                    className="d-inline-block me-3"
                                    type="checkbox"
                                    name="is_admin"
                                    label={_CT("user.isAdmin")}
                                    checked={formData.is_admin}
                                    onChange={handleChange}
                                />
                                <Form.Check
                                    className="d-inline-block me-3"
                                    type="checkbox"
                                    name="is_tech"
                                    label={_CT("user.isTech")}
                                    checked={formData.is_tech}
                                    onChange={handleChange}
                                />
                                <Form.Check
                                    className="d-inline-block me-3"
                                    type="checkbox"
                                    name="is_maint"
                                    label={_CT("user.isMaint")}
                                    checked={formData.is_maint}
                                    onChange={handleChange}
                                />
                                <Form.Check
                                    className="d-inline-block me-3"
                                    type="checkbox"
                                    name="dri_user"
                                    label={_CT("user.isDriver")}
                                    checked={formData.dri_user}
                                    onChange={handleChange}
                                />
                                {/* <Form.Check
                                    className="d-inline-block me-3"
                                    type="checkbox"
                                    name="is_viewer"
                                    label={_CT("user.isViewer")}
                                    checked={formData.is_viewer}
                                    onChange={handleChange}
                                />
                                <Form.Check
                                    className="d-inline-block me-3"
                                    type="checkbox"
                                    name="is_report"
                                    label={_CT("user.isReport")}
                                    checked={formData.is_report}
                                    onChange={handleChange}
                                /> */}
                            </div>
                        </div>
                        <div className="row mt-3">
                            <hr className="col-10 m-auto mb-4" />
                            <div className="col-12 text-center">
                                <h5 className="mb-3">{_CT("user.Alerts")}</h5>
                                <Form.Check
                                    className="d-inline-block me-3"
                                    type="checkbox"
                                    name="is_fireman"
                                    label={_CT("user.isFireman")}
                                    checked={formData.is_fireman}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            {/* <hr className="col-10 m-auto mb-4" /> */}
                            {/* <div className="col-12 text-center">
                                <h5 className="mb-3">{_CT("user.receiveEmails")}</h5>
                                <Form.Check
                                    className="d-inline-block me-3"
                                    type="checkbox"
                                    name="mail_alarm"
                                    label={_CT("user.alarms")}
                                    checked={formData.mail_alarm}
                                    onChange={handleChange}
                                />
                            </div> */}
                        </div>
                        {isNew ? (
                            <div className="row">
                                <div className="col-12 text-center">
                                    <small>{_CT("user.emailInvitation")}</small>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                        <div className="row fixed-bottom me-3">
                            <div className="text-end col-12 mb-4">
                                <button type="button" className="btn btn-secondary me-4" onClick={handleClose}>
                                    {_Tr("labels.cancel")}
                                </button>
                                <FormButton type="submit" className="btn btn-primary" isProcessing={isLoading}>
                                    {_Tr("labels.save")}
                                </FormButton>
                            </div>
                        </div>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormUser;
